﻿import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import AddBatchBenchSheet from './AddBatchBenchSheet';
import { RawMaterialBatch } from '../models/raw-material-batch';
import { RawMaterialBenchSheet } from '../models/RawMaterials/raw-material-bench-sheet';
import { BenchSheetTechnologyType } from '../models/enums';
import { BenchSheetCreation } from '../models/bench-sheet-creation';
import { CrudFunctions } from '../utilities/crud-functions';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';
import { ToastProps } from '../models/toast-props';

import DataGrid, {
    Column,
    Paging,
    Toolbar,
    Selection,
    Item as ToolbarItem,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Toast } from 'devextreme-react/toast';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';

export interface Props {
    rawMaterialBatchId: string;
    isReadOnly: boolean;
}

export default function RawMaterialBenchSheetData(props: Props) {
    const navigate = useNavigate();

    const [rawMaterialBenchSheets, setRawMaterialBenchSheets] =
        useState<RawMaterialBenchSheet[]>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getAllData();
    }, [props.rawMaterialBatchId]);

    return (
        <div className="pw-margin-top-05">
            <div className="pw-comp-row">
                <div className="pw-form-unit">
                    <Button text="Create Bench Sheets" type="success"
                        hint="create all bench sheets"
                        height={'2.6em'} disabled={props.isReadOnly}
                        onClick={onCreateBenchSheetsClick} />
                </div>
            </div>

            <div className="pw-margin-top-05">
                <DataGrid
                    height="28rem"
                    dataSource={rawMaterialBenchSheets ?
                        rawMaterialBenchSheets : []}
                    onRowDblClick={onBatchBenchSheetsRowDoubleClick}
                    rowAlternationEnabled={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Selection mode={'single'} />
                    <Paging enabled={false} />

                    <Column dataField='state' width='3rem' cellRender={benchSheetStateCellRender} />
                    <Column dataField='technologyName' dataType="string" caption="Technology" width='7rem' />
                    <Column dataField='createDate' dataType="string" caption="Date" width='10rem' />
                    <Column dataField='analysisTypesString' dataType="string" caption="Analysis Types" width='15rem' />
                    <Column dataField='basisTypesString' dataType="string" caption="Basis Types" width='15rem' />
                    <Column width='3rem' caption="Edit" alignment="center" cellRender={gotoBenchSheetCellRender} />
                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Raw Material Bench Sheets</div>
                            </div>
                        </ToolbarItem>
                    </Toolbar>

                </DataGrid>
            </div>

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    function onBatchBenchSheetsRowDoubleClick(e: any) {
        if (e.data && e.data.technologyId && e.data.benchSheetId)
            navigate(`/rmbenchsheet/${e.data.technologyId}/${e.data.benchSheetId}`);
    }

    async function onCreateBenchSheetsClick() {

        console.log("onCreateBenchSheetsClick");
        console.log(props.rawMaterialBatchId);

        if (!props.rawMaterialBatchId)
            return;

        console.log(121);

        createBenchSheets(props.rawMaterialBatchId)
            .then((data) => {
                let benchSheetCreations = data as BenchSheetCreation[];

                if (benchSheetCreations) {
                    let message = 'The following Bench Sheets were created: <br />';

                    benchSheetCreations.forEach((c: BenchSheetCreation) => {
                        message += '<br />';
                        if (c.benchSheetTechnology)
                            message += `${BenchSheetTechnologyType[c.benchSheetTechnology]}: ${c.success ? "SUCCESS" : "ERROR"}`;

                        if (!c.success)
                            message += `   ${c.errorMessage}`;
                    });

                    //TODO: show for success and for fails... and make toast remain until clicked on

                    showToast(message, "success");

                    getBatchBenchSheets();
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Creating Bench Sheets");
            });
    }

    async function getBatchBenchSheets() {
        if (props.rawMaterialBatchId) {
            await CrudFunctions.getData(`rawmaterials/rawmaterialbenchsheets/${props.rawMaterialBatchId}`)
                .then(data => {

                    console.log("RM BS:");
                    console.log(data);

                    setRawMaterialBenchSheets(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Bench Sheets");
                });
        }
    }

    async function createBenchSheets(batchId: string) {
        return CrudFunctions.postData(`rawmaterials/createrawmaterialbatchbenchsheets/${props.rawMaterialBatchId}`, null);
    }

    async function getAllData() {
        getBatchBenchSheets();
    }

    //show/hide


    //render

    function benchSheetStateCellRender(e: any) {
        if (e.data) {
            if (e.data.benchSheetId)
                return <div><i className="dx-icon-runner"></i></div>;
            else
                return <div><i className="dx-icon-rename"></i></div>;
        }

        return <div><i className="dx-icon-help"></i></div>;
    }

    function gotoBenchSheetCellRender(e: any) {
        if (e.data) {
            let benchSheet = e.data as RawMaterialBenchSheet;

            if (benchSheet && benchSheet.technologyId && benchSheet.benchSheetId) {
                let path = `/rmbenchsheet/${benchSheet.technologyId}/${benchSheet.benchSheetId}`;

                return <NavLink to={path} className="datagrid-icon-link"><div className="dx-icon-edit datagrid-icon"></div></NavLink>;
            }
            else
                return <div></div>;
        }

        return <div></div>;
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}
